import React from "react";
import "./Analysis.css";
import { MainAnalysis } from "./mainAnalysis/MainAnalysis";

// MainAnalysis is the only analysis page.
export const Analysis = () => (
  <div className="Analysis">
    <MainAnalysis />
  </div>
);
